import { gql } from "@apollo/client";

export const GET_ALL_NOTIFICATIONS_GQL = gql`
query GetNotification($category: String, $page: Int, $pageSize: Int, $search: String, $type: String, $status: String, $typeReceiver: String) {
  notification(category: $category, page: $page, pageSize: $pageSize, search: $search, type: $type, status: $status, typeReceiver: $typeReceiver) {
    items {
      buttonAction
      category
      count
      createDate
      description
      doEntryId
      externalReferenceCode
      linkDescription
      name
      notificationId
      pathName
      payload
      receiverId
      receiverName
      senderAvatar
      senderId
      senderName
      status
      statusDate
      taskAssignmetnInstanceId
      type
      typeReceiver
      __typename
    }
    page
    pageSize
    totalCount
    __typename
  }
}  
`;

